import { Box, CircularProgress, Divider } from "@mui/joy";
import { Plus } from "lucide-react";
import { Link } from "react-router-dom";

import { DataGridSetting } from "../../../../components";
import { Alert, Button } from "../../../../shared";
import { usePlatformAdmin } from "../../../../hooks/query";
import { useAuthorization } from "../../../../hooks";
import { ROLES } from "../../../../constants/permissions";

import { columnDef } from "./column-def";
import Breadcrumb from "./Breadcrumb";

import type { IPlatformAdmin } from "../../../../interfaces";

export default function List() {
    const { hasRole } = useAuthorization();
    const isSuperAdmin = hasRole(ROLES.SUPER_ADMIN);
    const { useList } = usePlatformAdmin();
    const { data, isLoading, isError, error } = useList();

    if (!isSuperAdmin) {
        return (
            <Box flex={1} p={3}>
                <Alert errorMessage="Only Super Admin can manage platform admins." />
            </Box>
        );
    }

    if (isLoading) {
        return (
            <Box flex={1} display="flex" justifyContent="center" alignItems="center">
                <CircularProgress />
            </Box>
        );
    }

    if (isError) {
        return (
            <Box flex={1} p={2}>
                <Box sx={{ color: "danger.plainColor" }}>
                    {error instanceof Error ? error.message : "Failed to load platform admins"}
                </Box>
            </Box>
        );
    }

    const admins = (data as IPlatformAdmin[]) || [];

    return (
        <Box flex={1} display="flex" flexDirection="column">
            <Breadcrumb />
            <Divider />
            <Box flex={1}>
                <DataGridSetting
                    gridData={admins}
                    columnDefs={columnDef}
                    quickControlStartDecorator={<CreateAdminButton />}
                />
            </Box>
        </Box>
    );
}

function CreateAdminButton() {
    return (
        <Box display="flex" alignItems="center" ml={1.5}>
            <Button
                variant="soft"
                color="primary"
                component={Link}
                to="/admin/tenant/admins/new"
                startDecorator={<Plus size={18} />}
            >
                New Admin
            </Button>
            <Divider orientation="vertical" sx={{ mt: 1, mb: 1, ml: 2 }} />
        </Box>
    );
}
